import React from "react";
import Button from "../../components/shared/button";
import ListView from "../../components/shared/list/listView";
import { TopToolbar } from "../../components/shared/list/topToolbar";
import {
  ListViewType,
  useList,
} from "../../components/shared/list/useListHook";
import { Text } from "../../components/shared/text";

import sampleImage1 from "../../styles/images/samples/sample_1.jpg";
import sampleImage2 from "../../styles/images/samples/sample_2.jpg";
import sampleImage3 from "../../styles/images/samples/sample_3.jpg";
import sampleImage4 from "../../styles/images/samples/sample_4.jpg";
import sampleImage5 from "../../styles/images/samples/sample_5.jpg";
import sampleImage6 from "../../styles/images/samples/sample_6.jpg";
import sampleImage7 from "../../styles/images/samples/sample_7.jpg";
import sampleImage8 from "../../styles/images/samples/sample_8.jpg";
import sampleImage9 from "../../styles/images/samples/sample_9.jpg";
import sampleImage10 from "../../styles/images/samples/sample_10.jpg";
import sampleImage11 from "../../styles/images/samples/sample_11.jpg";
import sampleImage12 from "../../styles/images/samples/sample_12.jpg";

/*import ItemImage1 from "../../styles/images/samples/sample_12.jpg"*/

// import ItemImage1 from "../../styles/images/items/item_1.png";
import ItemImage2 from "../../styles/images/items/item_2.png";
// import ItemImage3 from "../../styles/images/items/item_3.png";
// import ItemImage4 from "../../styles/images/items/item_4.png";



import Marquee from "../../components/Marquee";
import Ripple from "../../components/Ripple";
//import { SvgDownload } from "components/svg";
import Checkbox from "components/shared/inputs/checkbox";
import Radio from "components/shared/inputs/radio";

const getRandomImage = () => {
  const sampleImages = [
    sampleImage1,
    sampleImage2,
    sampleImage3,
    sampleImage4,
    sampleImage5,
    sampleImage6,
    sampleImage7,
    sampleImage8,
    sampleImage9,
    sampleImage10,
    sampleImage11,
    sampleImage12,
  ];
  const randomIndex = Math.floor(Math.random() * sampleImages.length);
  return sampleImages[randomIndex];
};

const getRandomName = () => {
  const RandomName = [
    "Bruce Banner",
    "Tony Stark",
    "Natasha Romanoff",
    "Thor Odinson",
    "Steve Rogers",
    "Yondu Udonta",
  ];
  const randomIndex = Math.floor(Math.random() * RandomName.length);
  return RandomName[randomIndex];
};

type DemoItem = {
  key: number;
  name: string;
  age: number;
  address: string;
  description: string;
  image: string;
};
const dataSource: DemoItem[] = [];

for (let i = 1; i <= 15; i++) {
  dataSource.push({
    key: i,
    name: getRandomName(),
    age: Number(`${i}2`),
    address: `${i}720 Goodrich Ct Platteville, Colorado`,
    description: `Mauris justo auctor in sollicitudin convallis  gravida non tortor etiam et vehicula elit`,
    image: getRandomImage(),
  });
}

const BlockItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <group
    data-direction="column"
    data-contain=""
    data-border=""
    data-radius="10"
    data-background="context"
    // data-react="scale"
    data-cursor="pointer"
  >
    <group data-ratio="5:4" data-shrink="no" data-contain="">
      {/* <text data-position="absolute" data-index="2" data-space-horizontal="20" data-color="white" data-text-size="64" data-weight="800" data-bottom="0">{data.key}</text> */}
      <picture >
        <img src={data.image} alt="" />
      </picture>
    </group>
    <group data-direction="column" data-contain="" data-gap="5" data-space="15">
      <Text
        data-text-size="medium"
        data-weight="700"
        data-color="main"
        data-ellipsis=""
      >
        {data.name}
      </Text>
      <Text data-wrap="wrap" data-clamp="3" data-line="1.5">
        {data.description}
      </Text>
    </group>
    <separator data-horizontal="" data-margin="none"></separator>
    <group data-gap="5" data-space="10" data-align="center" data-justify="end" >
      <Button material text="Open" />

      <separator data-vertical=""></separator>
      <Button micro material icon="arrow_outward" />
    </group>
  </group>
);

const ListItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <Ripple>
    <group
      data-align="center"
      data-space="5"
      data-gap="5"
      data-wrap="no"
      data-radius="10"
      data-contain=""
      data-cursor="pointer"
    >
      <group data-ratio="1:1" data-length="50" data-shrink="no" data-index="1">
        <picture data-radius="5">
          <img src={data.image} alt="" />
        </picture>
      </group>
      <group data-direction="column" data-contain="" data-space="5" data-index="1">
        <Text data-weight="700" data-ellipsis="">
          {data.name}
        </Text>
        <Marquee>
          <Text data-ellipsis="" data-light="">
            {data.description}
          </Text>
        </Marquee>
      </group>
      <separator data-vertical=""></separator>
      <group
        data-align="center"
        data-wrap="no"
        data-position="right"
        data-width="auto"
        data-index="1"
      >
        <Button mini rounded>
          <icon>more_vert</icon>
        </Button>
      </group>
    </group>
  </Ripple>
);

const GridItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <group data-align="center" data-space="10" data-gap="10" data-wrap="no">
    <group data-ratio="1:1" data-length="50" data-shrink="no">
      <picture>
        <img data-radius="5" src={data.image} alt="" />
      </picture>
    </group>
    <group data-direction="column" data-contain="">
      <Text data-weight="700">{data.name}</Text>
      <Text data-ellipsis="">{data.description}</Text>
    </group>
    <separator data-vertical=""></separator>
    <group
      data-align="center"
      data-wrap="no"
      data-position="right"
      data-width="auto"
    >
      <Button mini rounded>
        <icon>more_vert</icon>
      </Button>
    </group>
  </group>

);

const ListViewDemo: React.FC = () => {
  const { toolbarProps } = useList({
    viewTypes: [ListViewType.Block, ListViewType.List, ListViewType.Grid],
    defaultViewType: ListViewType.Block,
  });
  return (
    <view data-vertical="">
      <view
        data-vertical="true"
        //  data-space="20"
        data-background="highlight"
        //  data-align="start"
        data-max-length="300"
      >
        <group
          data-border=""
          //  data-radius="10"
          data-contain=""
          data-background="main-background"
          data-wrap="no"
          data-direction="column"
          data-max-height="fit"
        >
          <TopToolbar {...toolbarProps} />
          {toolbarProps.viewType === ListViewType.Block && (
            <ListView
              dataSource={dataSource}
              view={ListViewType.Block}
              keyField="key"
              data-template="190"
              scrollerProps={{ "data-space": "20" }}
              listProps={{ "data-gap": "10" }}
              itemComponent={BlockItem}
            />
          )}
          {toolbarProps.viewType === ListViewType.Grid && (
            <ListView
              view={ListViewType.Grid}
              dataSource={dataSource}
              keyField="key"
              data-space="10"
              itemComponent={GridItem}
            />
          )}
          {toolbarProps.viewType === ListViewType.List && (
            <ListView
              data-template="200"
              view={ListViewType.List}
              dataSource={dataSource}
              keyField="key"
              data-space="5"
              listProps={{ "data-space": "10", "data-gap": "10" }}
              itemComponent={ListItem}
            />
          )}
          <group
            data-border="overprint"
            data-align="center"
            data-gap="10"
            data-space="10"
            data-index="2"
          >
            <icon>arrow_outward</icon>
            <text>Footer Goes Here</text>
          </group>
        </group>
      </view>
      <view data-background="main-color-custom-lighter" data-scroll="">

        <group data-space="20" data-direction="column" data-gap="20">


          <group
            data-direction="column"
            data-border=""
            data-radius="5"
            data-contain=""
            data-background="white"
          >
            <group data-align="center" data-gap="5">
              <group data-position="left" data-align="center" data-width="auto" data-gap="10" data-background="main-color-custom-light" data-space="5">
                <icon data-icon-size="24" data-color="main">thumb_up_off_alt</icon>
                <text data-text-size="12">Recommandé par Atlantic</text>
              </group>
              <group data-length="autofit"></group>
            </group>



            <group data-space="20" data-gap="20" data-wrap="no">
              <group data-direction="column" data-gap="10">
                <group data-ratio="1:1" data-shrink="no" data-length="120" data-radius="5">
                  <picture><img src={ItemImage2} alt="" /></picture>
                  <group data-position="absolute" data-bottom="-5" data-right="-5" data-width="auto">
                    <icon data-color="white" data-background="success-color" data-radius="30" data-length="30" data-height="30" data-icon-size="30" data-fill>check</icon>
                  </group>
                </group>
                <group data-text-size="large" data-color="grey-color-mid">
                  <Checkbox
                    name="1"
                    label="Comparer"
                    checkbox
                  //={control}
                  />
                </group>
              </group>
              <group data-direction="column">
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  Alfea Extense A.I.
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  10 R32
                </text>
                <text data-text-size="large" data-color="grey-color-dark">
                  Monobloc
                </text>
                <space data-height="10"></space>
                <text data-text-size="medium" data-color="grey-color-dark">
                  Code article : 123456
                </text>
              </group>

              <group data-direction="column" >
                <text data-text-size="14" data-color="grey-color-mid">
                  de base
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  99,8 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Thermodynamique
                </text>
                <text data-text-size="large" >
                  99,8 %
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Global
                </text>
                <text data-text-size="large" >
                  79 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Chauffage
                </text>
                <text data-text-size="large" >
                  742 €
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Rafraîchissement
                </text>
                <text data-text-size="large" >
                  29 €
                </text>
              </group>


              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  COP
                </text>
                <text data-text-size="large" >
                  5,44
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  EER
                </text>
                <text data-text-size="large" >
                  5.1
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid" data-gap="20">
                <group data-align="center" data-wrap="no" data-gap="10">
                  <text data-text-size="large" data-weight="600" >9 279 €</text>
                  <group data-width="auto" data-space="3" data-space-horizontal="10" data-radius="5" data-background="success-color" data-color="white"><text data-text-size="12">Promotion</text></group>
                </group>
                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button large secondary outline" ><text>Sélectionné</text></div>
                </group>

                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button secondary simple">
                    <icon data-fill="" data-icon-size="28" data-color="secondary">add_circle</icon>
                    <text>Détails produit</text>
                  </div>
                </group>
              </group>

            </group>

          </group>

          <group
            data-direction="column"
            data-border=""
            data-radius="5"
            data-contain=""
            data-background="white"
          >
            <group data-align="center" data-gap="5">
              <group data-position="left" data-align="center" data-width="auto" data-gap="10" data-background="main-color-custom-light" data-space="5">
                <icon data-icon-size="24" data-color="main">thumb_up_off_alt</icon>
                <text data-text-size="12">Recommandé par Atlantic</text>
              </group>
              <group data-length="autofit"></group>
            </group>



            <group data-space="20" data-gap="20" data-wrap="no">
              <group data-direction="column" data-gap="10">
                <group data-ratio="1:1" data-shrink="no" data-length="120" data-radius="5">
                  <picture><img src={ItemImage2} alt="" /></picture>
                  <group data-position="absolute" data-bottom="-5" data-right="-5" data-width="auto">
                    <icon data-color="white" data-background="error" data-radius="30" data-length="30" data-height="30" data-icon-size="30" data-fill>info</icon>
                  </group>
                </group>
                <group data-text-size="large" data-color="grey-color-mid">
                  <Checkbox
                    name="1"
                    label="Comparer"
                    checkbox
                  //={control}
                  />
                </group>
              </group>
              <group data-direction="column">
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  Alfea Extense A.I.
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  10 R32
                </text>
                <text data-text-size="large" data-color="grey-color-dark">
                  Monobloc
                </text>
                <space data-height="10"></space>
                <text data-text-size="medium" data-color="grey-color-dark">
                  Code article : 123456
                </text>
              </group>

              <group data-direction="column" >
                <text data-text-size="14" data-color="grey-color-mid">
                  de base
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  99,8 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Thermodynamique
                </text>
                <text data-text-size="large" >
                  99,8 %
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Global
                </text>
                <text data-text-size="large" >
                  79 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Chauffage
                </text>
                <text data-text-size="large" >
                  742 €
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Rafraîchissement
                </text>
                <text data-text-size="large" >
                  29 €
                </text>
              </group>


              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  COP
                </text>
                <text data-text-size="large" >
                  5,44
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  EER
                </text>
                <text data-text-size="large" >
                  5.1
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid" data-gap="20">
                <group data-align="center" data-wrap="no" data-gap="10">
                  <text data-text-size="large" data-weight="600" >9 279 €</text>
                  <group data-width="auto" data-space="3" data-space-horizontal="10" data-radius="5" data-background="success-color" data-color="white"><text data-text-size="12">Promotion</text></group>
                </group>
                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button large secondary primary" ><icon data-icon-size="28">check_circle</icon><text>Sélectionné</text></div>
                </group>

                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button secondary simple">
                    <icon data-fill="" data-icon-size="28" data-color="secondary">add_circle</icon>
                    <text>Détails produit</text>
                  </div>
                </group>
              </group>

            </group>

          </group>

          <group
            data-direction="column"
            data-border=""
            data-radius="5"
            data-contain=""
            data-background="white"
          >
            <group data-align="center" data-gap="5">
              <group data-position="left" data-align="center" data-width="auto" data-gap="10" data-background="main-color-custom-light" data-space="5">
                <icon data-icon-size="24" data-color="main">thumb_up_off_alt</icon>
                <text data-text-size="12">Recommandé par Atlantic</text>
              </group>
              <group data-length="autofit"></group>
            </group>



            <group data-space="20" data-gap="20" data-wrap="no">
              <group data-direction="column" data-gap="10">
                <group data-ratio="1:1" data-shrink="no" data-length="120" data-radius="5">
                  <picture><img src={ItemImage2} alt="" /></picture>
                  <group data-position="absolute" data-bottom="-5" data-right="-5" data-width="auto">
                    <icon data-color="success-color" data-radius="30" data-length="30" data-height="30" data-icon-size="30" data-fill>contrast</icon>
                  </group>
                </group>
                <group data-text-size="large" data-color="grey-color-mid">
                  <Checkbox
                    name="1"
                    label="Comparer"
                    checkbox
                  //={control}
                  />
                </group>
              </group>
              <group data-direction="column">
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  Alfea Extense A.I.
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  10 R32
                </text>
                <text data-text-size="large" data-color="grey-color-dark">
                  Monobloc
                </text>
                <space data-height="10"></space>
                <text data-text-size="medium" data-color="grey-color-dark">
                  Code article : 123456
                </text>
              </group>

              <group data-direction="column" >
                <text data-text-size="14" data-color="grey-color-mid">
                  de base
                </text>
                <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  99,8 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Thermodynamique
                </text>
                <text data-text-size="large" >
                  99,8 %
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Global
                </text>
                <text data-text-size="large" >
                  79 %
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  Chauffage
                </text>
                <text data-text-size="large" >
                  742 €
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  Rafraîchissement
                </text>
                <text data-text-size="large" >
                  29 €
                </text>
              </group>


              <group data-direction="column" data-color="grey-color-mid">
                <text data-text-size="14">
                  COP
                </text>
                <text data-text-size="large" >
                  5,44
                </text>
                <space data-height="5"></space>
                <text data-text-size="14">
                  EER
                </text>
                <text data-text-size="large" >
                  5.1
                </text>
              </group>

              <group data-direction="column" data-color="grey-color-mid" data-gap="20">
                <group data-align="center" data-wrap="no" data-gap="10">
                  <text data-text-size="large" data-weight="600" >9 279 €</text>
                  <group data-width="auto" data-space="3" data-space-horizontal="10" data-radius="5" data-background="success-color" data-color="white"><text data-text-size="12">Promotion</text></group>
                </group>
                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button large secondary primary" ><icon data-icon-size="28">check_circle</icon><text>Sélectionné</text></div>
                </group>

                <group data-align="center" data-wrap="no" data-gap="10">
                  <div className="button secondary simple">
                    <icon data-fill="" data-icon-size="28" data-color="secondary">add_circle</icon>
                    <text>Détails produit</text>
                  </div>
                </group>
              </group>

            </group>

          </group>


          <group
            data-length="autofit"
            data-direction="column"
            data-border=""
            data-radius="5"
            data-contain=""
            data-background="white"
            data-max-length="500"
          >
            {/*<group data-align="center" data-gap="5">
              <group data-position="left" data-width="auto" data-gap="10" data-background="main-color-custom-light" data-space="5">
                <icon data-svg-size="16" data-svg-color="main">
                  <SvgDownload />
                </icon>
                <text data-text-size="12">Recommandé par Atlantic</text>
              </group>
              <group data-length="autofit"></group>
            </group>*/}



            <group data-space="20" data-gap="10" data-direction="column">

              <group data-gap="20" data-width="auto" data-wrap="no" >
                <group data-width="auto" data-align="center" data-justify="center" data-wrap="no">
                  <Radio
                    name="1"
                    //label="Comparer"
                    checkbox
                  />
                  <group data-direction="column" data-width="auto" >
                    <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                      Alfea Extense A.I.
                    </text>
                    <text data-text-size="large" data-weight="600" data-color="grey-color-dark">
                      10 R32
                    </text>
                    <text data-text-size="large" data-color="grey-color-dark">
                      Monobloc
                    </text>
                    <space data-height="10"></space>
                    <text data-text-size="medium" data-color="grey-color-dark">
                      Code article : 123456
                    </text>
                  </group>
                </group>
                <group data-position="right" data-ratio="1:1" data-shrink="no" data-length="120" data-radius="5">
                  <picture><img src={ItemImage2} alt="" /></picture>
                </group>
              </group>
              <separator data-horizontal=""></separator>

              <group data-wrap="no" data-gap="20">
                <text data-length="autofit" data-text-size="medium" data-color="grey-color-mid">
                  Taux couverture à température de base
                </text>
                <text data-length="autofit" data-text-size="large" data-weight="600" data-color="grey-color-dark">
                  99,8 %
                </text>
                <group data-width="auto">
                  <icon data-color="success-color" data-radius="30" data-length="30" data-height="30" data-icon-size="30" data-fill>contrast</icon>
                </group>
              </group>
              <group data-wrap="no" data-gap="20">
                <text data-length="autofit" data-text-size="medium" data-color="grey-color-mid">
                  Prix HT conseillé
                </text>
                <text data-length="autofit" data-text-size="large" data-text-align="right" data-color="grey-color-dark">
                  9 279 €
                </text>
              </group>
              <group data-gap="20" data-align="center">
                <div className="button large secondary " data-length="forcefit" data-fit="1"><icon data-icon-size="28">check_circle</icon><text data-width="auto">Sélectionné</text></div>
              </group>
              <separator data-horizontal=""></separator>


              <group data-gap="20" data-align="center">
                <div className="button large secondary outline" data-length="forcefit" data-fit="1"><icon data-icon-size="28">check_circle</icon><text data-width="auto">Sélectionné</text></div>
                <div className="button large secondary simple" data-length="forcefit" data-fit="1">
                  <icon data-fill="" data-icon-size="28" data-color="secondary" >add_circle</icon>
                  <text data-width="auto">Détails produit</text>
                </div>
              </group>
            </group>

          </group>


          <group data-direction="column" data-gap="20">
            <group
              data-color="main-light"
              data-border="inheret"

            >
              <group
                data-direction="column"
                data-contain=""
                data-background="white"
              >


                <group data-space="20" data-gap="20" data-wrap="no">
                  <group data-ratio="1:1" data-shrink="no" data-length="120" data-radius="5">
                    <picture><img src={ItemImage2} alt="" /></picture>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="50">
                        Code article
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-width="auto" data-align="center">
                      <text data-text-size="large">
                        522476
                      </text>
                    </group>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-text-align="center">
                        Désignation
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="large" data-align="center">
                        Alféa Extensa A.I. 5 R32
                      </text>
                    </group>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-text-align="center">
                        Quantité
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid">
                      <group data-align="center" data-width="auto">

                      </group>
                    </group>
                  </group>


                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="120" data-text-align="center">
                        Prix public conseillé HT (€)
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center" data-width="auto">
                        7 138,00€
                      </text>
                    </group>
                  </group>


                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center">
                        Taux de remise
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" >
                      <group data-align="center" data-width="auto">

                      </group>
                    </group>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">

                      <text data-text-size="14" data-wrap="wrap" data-length="80" data-text-align="center">
                        Eco-part. HT (€)
                      </text>

                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center" data-width="auto">
                        6,00 €
                      </text>
                    </group>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center">
                        Total HT (€)
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-dark" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-length="100" data-weight="600" data-text-align="center">
                        7 144,00 €
                      </text>
                    </group>
                  </group>

                  <group data-direction="column" data-wrap="no" data-gap="10" data-length="" data-align="center" data-width="auto">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-text-align="center"></text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-dark" data-align="center" data-width="auto">
                      <div className="button mini" ><icon data-icon-size="28">delete</icon></div>
                    </group>
                  </group>

                </group>
              </group>

            </group>
            <group data-gap="20" data-wrap="no">
              <group data-length="autofit" data-gap="20">
                <div className="button large secondary outline" data-length="forcefit"><icon data-icon-size="28">add</icon><text data-width="auto">Ajouter une ligne</text></div>
                <div className="button large secondary simple" data-length="forcefit"><icon data-icon-size="28">note</icon><text data-width="auto">Ajouter une note personnelle</text></div>
              </group>
              <group data-length="autofit" data-gap="20" data-align="center">
                <text data-text-size="large" data-length="autofit" data-weight="300">Total HT</text>
                <text data-text-size="large" data-length="autofit" data-text-align="left" data-weight="700">154,12 €</text>
              </group>
            </group>
          </group>



          <group data-direction="column" data-gap="20" data-max-length="500">
            <group
              data-color="main-light"
              data-border="inheret"

            >
              <group
                data-contain=""
                data-background="white"
              >
                <group data-space="20" data-gap="20" data-wrap="no" data-direction="column">
                  <group data-wrap="no" data-direction="column">
                    <group data-length="autofit" data-color="grey-color-mid" data-width="auto" data-align="center">
                      <text data-text-size="large" data-weight="600">
                        Navilink A59 NB
                      </text>
                    </group>
                    <group data-length="autofit" data-color="grey-color-mid" data-width="auto" data-align="center">
                      <text data-text-size="large">
                        Code article : 522476
                      </text>
                    </group>

                  </group>
                  <separator data-horizontal="" data-margin="none"></separator>

                  <group data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-text-align="center">
                        Quantité
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-justify="end">
                      <group data-align="center" data-width="auto">

                      </group>
                    </group>
                  </group>

                  <group data-wrap="no" data-gap="10" data-align="center">
                    <group data-length="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap">
                        Prix public conseillé HT
                      </text>
                    </group>
                    <group data-length="autofit" data-color="grey-color-mid" data-width="auto" data-align="center" data-justify="end">
                      <text data-text-size="large">
                        154,00€
                      </text>
                    </group>
                  </group>

                  <group data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                    <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap" data-text-align="center">
                        Taux de remise
                      </text>
                    </group>
                    <group data-height="autofit" data-color="grey-color-mid" data-justify="end">
                      <group data-align="center" data-width="auto">

                      </group>
                    </group>
                  </group>

                  <group data-wrap="no" data-gap="10" data-align="center">
                    <group data-length="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap">
                        Eco-part. HT
                      </text>
                    </group>
                    <group data-length="autofit" data-color="grey-color-mid" data-width="auto" data-align="center" data-justify="end">
                      <text data-text-size="large">
                        0,12 €
                      </text>
                    </group>
                  </group>

                  <group data-wrap="no" data-gap="10" data-align="center">
                    <group data-length="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                      <text data-text-size="14" data-wrap="wrap">
                        Total HT
                      </text>
                    </group>
                    <group data-length="autofit" data-color="grey-color-mid" data-width="auto" data-align="center" data-justify="end">
                      <text data-text-size="large" data-weight="600">
                        154,12 €
                      </text>
                    </group>
                  </group>
                  <separator data-horizontal="" data-margin="none"></separator>


                  <group data-wrap="no" data-gap="10" data-length="" data-align="center" data-width="auto">
                    <group data-height="autofit" data-color="grey-color-dark" data-align="center" data-width="auto">
                      <div className="button mini secondary simple" ><icon data-icon-size="30">delete</icon></div>
                    </group>
                  </group>
                </group>
              </group>

            </group>
            <group data-gap="20" data-direction="column" data-align="center">
              <group data-width="auto" data-gap="20">
                <div className="button large secondary outline" data-length="forcefit"><icon data-icon-size="28">add</icon><text data-width="auto">Ajouter une ligne</text></div>
              </group>
              <group data-length="autofit" data-gap="20" data-align="center">
                <text data-text-size="large" data-length="autofit"></text>
                <text data-text-size="large" data-length="autofit" data-text-align="center" data-weight="300">Total HT</text>
                <text data-text-size="large" data-length="autofit" data-text-align="center" data-weight="700">154,12 €</text>
              </group>
              <group data-width="auto" data-gap="20">
                <div className="button large secondary simple" data-length="forcefit"><icon data-icon-size="28">note</icon><text data-width="auto">Ajouter une note</text></div>
              </group>
            </group>
          </group>

        </group>


      </view>

      { /* <view>
     <div className="list_view_container" data-scroll="" data-template="260">
          <group className="list_view_scroller" data-space="20">
            <div className="list_view">
              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage1} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage2} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage3} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage4} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>
            </div>
          </group>
        </div>

      </view>*/}
      {/* <view data-adaptive="desktop"></view> */}
    </view>
  );
};
export default ListViewDemo;
